<div class="mission-create">
  <div class="options">
    <app-select-market></app-select-market>
  </div>

  @if (selectedMarket) {
    <div class="mission-create-ctn">
      <div class="mission-create-title">
        <h1>Create new mission</h1>
      </div>
      <div class="mission-create-rru-selection">
        <label>Refining Corporation / Refinery / Unit</label>
        <mat-form-field class="rounded">
          <i class="ph ph-magnifying-glass" matPrefix></i>
          <input type="text"
            placeholder="Pick one"
            aria-label="Refining Corporation / Refinery / Unit"
            matInput
            [formControl]="rruFC"
            [matAutocomplete]="auto"
            matAutocompletePosition="below">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnRRU">
            @for (option of (filteredRruList$ | async); track option) {
              <mat-option [value]="option">
                <span [innerHTML]="option.value | highlight: showHighlight ? rruFC.value : ''"></span>
              </mat-option>
            }
          </mat-autocomplete>
          @if (rruFC.hasError('required')) {
            <mat-error>
              Please enter a value
            </mat-error>
          }
          @if (!rruFC.hasError('required') && rruFC.hasError('incorrect')) {
            <mat-error>
              Please select a valid R-R-U
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="mission-create-retrieve-data">
        <label for="retrieveData">Retrieve data from questionnaire</label>
        <mat-form-field class="multiple-line-select" [ngClass]="{'invisible': questionnaireIdFC.value }">
          @if (questionnaireIdFC.enabled) {
            <mat-label>Select an existing questionnaire from the list</mat-label>
          }
          <mat-select #dataSelector id="retrieveData" [formControl]="questionnaireIdFC"
            [compareWith]="compareById">
            @for (questionnaire of (questionnaireDataList$ | async); track questionnaire) {
              <mat-option class="multiline-option" [value]="questionnaire.preparationPk"
                [disabled]="questionnaire.disabled">
                <div>Sulfiding date:
                {{ !!questionnaire.sulfidingDate ? (questionnaire.sulfidingDate | questionnaireTimestampToDate:'EMEA') : ' - ' }}</div>
                <div>Questionnaire status: <app-chip-status [status]="questionnaire.status"></app-chip-status> {{ questionnaire.status?.value }}</div>
                <div>Mission status: {{ questionnaire.missionStatus?.value }}</div>
              </mat-option>
            }
            <mat-option class="multiline-option" [value]="-1">
              <div class="small">Manual creation without reference to a questionnaire</div>
              <button mat-button color="primary" class="minimal rounded">
                <i class="ph ph-wrench"></i>
                CREATE MANUALLY
              </button>
            </mat-option>
          </mat-select>
        </mat-form-field>
        @if (!!questionnaireIdFC.value && (selectedData$ | async); as selectedData) {
          <div class="fake-selector-ctn">
            <div class="fake-selector-content">
              @if (questionnaireIdFC.value !== -1) {
                <div>Sulfiding date: {{ !!selectedData.sulfidingDate ? (selectedData.sulfidingDate | questionnaireTimestampToDate:'EMEA') : ' - ' }}</div>
                <div>Questionnaire status: {{ selectedData.status?.value }}</div>
                <div>Mission status: {{ selectedData.missionStatus?.value }}</div>
              } @else {
                <div class="small">Manual creation without reference to a questionnaire</div>
                <button mat-button color="primary" class="minimal rounded"
                  (click)="onCreateManuallyClickHandler()">
                  <i class="ph ph-wrench"></i>
                  CREATE MANUALLY
                </button>
              }
            </div>
            <div class="fake-selector-button">
              <button mat-icon-button class="x-minimal" (click)="onResetSelectionData()" color="warn">
                <i class="ph ph-x"></i>
              </button>
            </div>
          </div>
        }
      </div>
      <div class="mission-create-fill-data">
        @if ((selectedData$ | async)?.preparationPk) {
          <div class="form-content">
            <div class="block">
              <label for="product">Product</label>
              <mat-form-field>
                <mat-select id="product" [formControl]="productFC" [compareWith]="compare">
                  @for (product of (productList$ | async); track product) {
                    <mat-option [value]="product.key">
                      {{ product.value }}
                    </mat-option>
                  }
                </mat-select>
                @if (rruFC.hasError('required')) {
                  <mat-error>
                    Please select a product
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="block">
              <label for="quantity">Quantity to deliver</label>
              <app-arkema-input-with-unit [class]="['width-150px']" labelId="quantity"
                [controlFC]="quantityFC"
                [unitControlFG]="quantityUnitFG"
                [unitList]="DMDS_QUANTITY_UNIT_LIST"
                [minValue]="VALIDATOR_MIN_DMDS_QTY"
                [maxValue]="VALIDATOR_MAX_DMDS_QTY"
                [hint]="'including contingency'"
              ></app-arkema-input-with-unit>
            </div>
            <div class="block">
              <label for="reactors">Number of reactors</label>
              <mat-form-field class="width-70px">
                <input matInput type="number" id="reactors"
                  [formControl]="nbReactorFC"
                  [min]="VALIDATOR_MIN_REACTOR" [max]="VALIDATOR_MAX_REACTOR">
                @if (nbReactorFC.hasError('required')) {
                  <mat-error
                  >{{ 'REQUIRED_FIELD' | translate }}</mat-error>
                }
                @if (nbReactorFC.hasError('min')) {
                  <mat-error>
                  Minimum value is {{VALIDATOR_MIN_REACTOR}}</mat-error>
                }
                @if (nbReactorFC.hasError('max')) {
                  <mat-error>
                  Maximum value is {{VALIDATOR_MAX_REACTOR}}</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="block">
              <label for="sulfidingDate">Estimated sulfiding date</label>
              <mat-form-field class="date-picker">
                <span matPrefix class="text-ellipsis">
                  {{ sulfidingDateFC?.value ? (sulfidingDateFC.value | date:'EEEE') : '-' }}
                </span>
                <input matInput id="sulfidingDate"
                  readonly="readonly" (click)="pickerSulfidingDate.open()"
                  [formControl]="sulfidingDateFC"
                  [matDatepicker]="pickerSulfidingDate">
                <mat-datepicker-toggle matSuffix [for]="pickerSulfidingDate">
                  <i class="ph ph-calendar" matDatepickerToggleIcon></i>
                </mat-datepicker-toggle>
                <mat-datepicker #pickerSulfidingDate></mat-datepicker>
                @if (sulfidingDateFC.hasError('required')) {
                  <mat-error
                  >{{ 'REQUIRED_FIELD' | translate }}</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="block">
              <label for="catalystWeight">Catalyst weight</label>
              <app-arkema-input-with-unit [class]="['width-150px']" labelId="catalystWeight"
                [controlFC]="catalystWeightFC"
                [unitControlFG]="catalystWeightUnitFG"
                [unitList]="CATALYST_WEIGHT_UNIT_LIST"
                [minValue]="VALIDATOR_MIN_CATALYST_WEIGHT"
                [maxValue]="VALIDATOR_MAX_CATALYST_WEIGHT"
                [hint]=""
              ></app-arkema-input-with-unit>
            </div>
          </div>
          <div class="form-button">
            <button mat-raised-button color="accent" class="big mat-elevation-z0"
              [disabled]="form.invalid" (click)="onValidateNewMissionClickHandler()">
              @if ((creating$ | async)) {
                <i class="ph ph-circle-notch-bold rotate"></i>
              }
              @if ((creating$ | async) === false) {
                <i class="ph ph-plus-circle"></i>
              }
              CREATE MISSION
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>
